import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Image from 'gatsby-image';
import BreadCrumbs from './Breadcrumbs';
import vars from '../lib/styled';

export const Header = styled.header`
    box-sizing: border-box;
    margin: 0 auto;
    padding: 7.5vh 6.5vw 5vh;
    position: relative;
    width: ${vars.container};
`;

export const HeaderHeadline = styled.h1``;
export const HeaderLeader = styled.p`
    margin-bottom: 1.5rem;
    width: 80%;
`;

export const HeaderDivider = styled.span`
    background-color: darkgoldenrod;
    display: block;
    margin: 1rem 0;
    height: 3px;
    width: 70px;
`;

const HeaderImage = styled.div`
    box-sizing: border-box;
    height: 450px;
    margin: 0 auto;
    max-width: 100%;
    overflow: hidden;
    position: relative;
    width: 90vw;
    z-index: 1;

    .gatsby-image-wrapper {
        height: 100%;
        object-fit: cover;
        width: 100%;
    }

    @media (min-width: ${vars.breakpoint.desktop}) {
        margin-left: auto !important;
        margin-right: 0;
        width: 92vw;
    }

    @media (max-width: ${vars.breakpoint.laptop}) {
        height: 300px;
        width: 85vw;
    }

    @media (max-width: ${vars.breakpoint.tablet}) {
        width: 95vw;
    }

    @media (max-width: ${vars.breakpoint.phone}) {
        width: 100%;
    }
`;

const Hero = ({ title, breadcrumbs, image }) => (
    <div style={{ backgroundColor: image ? vars.contrast : undefined }}>
        <Header>
            <HeaderHeadline>
                {title.split('(').map((sentence, i) => {
                    if (i === 0) return sentence;
                    return (
                        <div style={{ fontSize: '60%' }}>{`(${sentence}`}</div>
                    );
                })}
            </HeaderHeadline>
            <hr aria-hidden="true" className="divider" />
            <BreadCrumbs title={title} breadcrumbs={breadcrumbs} />
        </Header>
        {image && (
            <HeaderImage aria-hidden={true}>
                <Image fluid={image.fluid} alt="" />
            </HeaderImage>
        )}
    </div>
);

Hero.propTypes = {
    title: PropTypes.string.isRequired,
    breadcrumbs: PropTypes.array,
    image: PropTypes.shape({
        title: PropTypes.string,
        fluid: PropTypes.object,
    }),
};

Hero.defaultProps = {
    image: null,
};

export default Hero;
